import React from 'react';

const PnbBadge = (props) => (
  <span className={`inline-flex items-center px-2 rounded-full text-sm font-medium ${props.color || 'bg-indigo-100 text-indigo-800'}`}>
    {props.title}
  </span>
);

export default PnbBadge;
